export type SponsorTier = 'main' | 'gold' | 'silver' | 'partner' | 'friend'

export const SPONSOR_TIERS: SponsorTier[] = ['main', 'gold', 'silver', 'partner', 'friend']

export interface Sponsor {
  id: number
  edition_id: number
  name: string
  tier: SponsorTier
  logo_url: string | null
  website_url: string | null
  sort_order: number
  created_at: string | null
  updated_at: string | null
}

export interface SponsorFormData {
  name: string
  tier: SponsorTier
  website_url: string | null
  sort_order: number
}
